import { Action, Dispatch, ThunkAction } from "@reduxjs/toolkit";
import {
  addAddress as addAddressApi,
  addOrder as addOrderApi,
  createUser as createUserApi,
  getOrderById as getOrderByIdApi,
  getUserByEmail as getUserByEmailApi,
} from "helpers/backend_helper";
import { RootState } from "slices";
import {
  addAddressError,
  addAddressSuccess,
  addOrderError,
  addOrderSuccess,
  createUserError,
  createUserSuccess,
  getOrderByIdError,
  getOrderByIdSuccess,
  getUserByEmailError,
  getUserByEmailSuccess,
  setIsLoading,
  setIsLoadingUser,
} from "./reducer";
import { toast } from "react-toastify";

export const getUserByEmail =
  (email: string): ThunkAction<void, RootState, unknown, Action<string>> =>
    async (dispatch: Dispatch) => {
      try {
        dispatch(setIsLoadingUser(true));
        const response: any = await getUserByEmailApi(email);
        // Check if the user exists in the response

        if (response.status === 200 && response.data.user) {
          dispatch(getUserByEmailSuccess(response.data.user));
          return response.data.user; // Return the response if user is found
        } else {
          // If user is not found, throw an error
          throw new Error("User  not found");
        }
      } catch (error: any) {
        // dispatch(setIsLoadingUser(false));
        dispatch(getUserByEmailError(error));
        throw error; // Rethrow the error to be caught in the calling function
      } finally {
        dispatch(setIsLoadingUser(false)); // Ensure loading state is reset
      }
    };

export const addAddress = (body: any) => async (dispatch: Dispatch) => {
  try {
    // dispatch(setIsLoading(true));
    const response: any = await addAddressApi(body);
    dispatch(setIsLoadingUser(false));
    dispatch(addAddressSuccess(response.result));
    toast.success("Address added Successfully!", { autoClose: 2000 });
    return response;
  } catch (error: any) {
    toast.error("Address added Failed!", { autoClose: 2000 });
    dispatch(setIsLoadingUser(false));
    dispatch(addAddressError(error));
  }
};

export const createUser = (body: any) => async (dispatch: Dispatch) => {
  try {
    // dispatch(setIsLoading(true));
    const response: any = await createUserApi(body);
    toast.success("User created Successfully!", { autoClose: 2000 });
    dispatch(setIsLoadingUser(false));
    dispatch(createUserSuccess(response.result));
    return response;
  } catch (error: any) {
    toast.error("User created Failed!", { autoClose: 2000 });
    dispatch(setIsLoadingUser(false));
    dispatch(createUserError(error));
  }
};
export const generateOrder = (body: any, navigate: any): ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch: Dispatch,) => {
  try {
    // dispatch(setIsLoading(true));
    const response: any = await addOrderApi(body);
    toast.success("Order added Successfully!", { autoClose: 2000 });
    // dispatch(setIsLoadingUser(false));
    dispatch(addOrderSuccess(response.result));
    navigate("/jewellery-orders")
    return response;
  } catch (error: any) {
    toast.error("Order added Failed!", { autoClose: 2000 });
    // dispatch(setIsLoadingUser(false));
    dispatch(addOrderError(error));

  }
};

export const getOrderById =
  (id: string): ThunkAction<void, RootState, unknown, Action<string>> =>
    async (dispatch: Dispatch) => {
      try {
        dispatch(setIsLoading(true));
        const response: any = await getOrderByIdApi(id);
        dispatch(setIsLoading(false));
        dispatch(getOrderByIdSuccess(response.result));
        return response.result;
      } catch (error: any) {
        dispatch(setIsLoading(false));
        dispatch(getOrderByIdError(error));
      }
    };